// extracted by mini-css-extract-plugin
module.exports = {"other":"General_other__14BYP"};